import React from 'react';
import './LandingPage.css';

const LandingPage = ({ onLogin, onDatenschutz, onImpressum, onUeberRefiReg, onAnwendungsfaelle }) => {
    return (
        <div className="landing-page">
            <div className="landing-content">
                <div className="landing-logo-container">
                    <img
                        src={`${process.env.PUBLIC_URL}/main.png`}
                        alt="SRR Logo"
                        className="landing-logo"
                    />
                    <div className="landing-title">
                        <span className="landing-title-top">Simple</span>
                        <span className="landing-title-bottom">RefiReg</span>
                    </div>
                </div>
                <button
                    className="landing-login-link"
                    onClick={onLogin}
                >
                    Login
                </button>
                <div className="landing-footer-group">
                    <div className="landing-about-link-container">
                        <button
                            className="landing-about-link"
                            onClick={onUeberRefiReg}
                            title="Erfahren Sie mehr über die Funktionen von RefiReg"
                        >
                            Über RefiReg
                        </button>
                        <button
                            className="landing-about-link"
                            onClick={onAnwendungsfaelle}
                            title="Refinanzierungsprozess visualisiert"
                        >
                            Anwendungsfälle
                        </button>
                    </div>
                    <div className="landing-footer">
                        <button
                            className="landing-footer-link"
                            onClick={onImpressum}
                        >
                            Impressum
                        </button>
                        <span className="landing-footer-separator">|</span>
                        <button
                            className="landing-footer-link"
                            onClick={onDatenschutz}
                        >
                            Datenschutz
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LandingPage;
